<template>
  <div class="navbar-for-rights van-hairline--bottom">
    <router-link to="/personalCenter">
      <div class="user-header" :style="{color: fontColor}">
        <icon name="user-circle-o" />
      </div>
    </router-link>
    <div class="search">
      <div class="search-bar">
        <input type="text" @focus="$emit('search', true)" />
      </div>
    </div>
    <router-link to="/shopingTrolley">
      <button class="shoping-cart" :style="{color: fontColor}">
        <icon name="cart-circle-o" />
        <span>购物车</span>
      </button>
    </router-link>
  </div>
</template>

<script>
import { Icon } from 'vant'
export default {
  name: 'navBarForRight',
  components: {
    Icon
  },
  data () {
    return {
      fontColor: '#404040'
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.navbar-for-rights {
  padding: 0 0.2rem;
  height: 0.88rem;
  background-color: #fff;
  .flex-between;
  color: @base;

  .user-header,
  .shoping-cart {
    .flex-center;
    font-size: 0.58rem;
    color: @base;
  }
  .shoping-cart {
    span {
      font-size: @fz24;
      padding-left: 0.15rem;
    }
  }
  .search {
    width: 4.3rem;
    padding: 0.15rem 0;
    .search-bar {
      width: 100%;
      padding-left: 0.63rem;
      border: 0.5px solid #d9d9d9;
      box-sizing: border-box;
      border-radius: 30px;
      height: 0.58rem;
      background: url("../assets/img/search.png") 0.14rem no-repeat;
      background-size: 0.3rem 0.3rem;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      vertical-align: top;
    }
  }
}
</style>
